<template>
  <div class="">
    <div class="d-flex align-items-center justify-content-end">
      <b-button
        @click="$router.push('/trading/tradings-management')"
        variant="primary"
      >
        <feather-icon icon="ArrowLeftIcon" />
        Back to Trading
      </b-button>
    </div>

    <div class="d-flex align-items-center mb-1 mt-1">
      <feather-icon icon="GridIcon" size="20" />
      <span style="font-weight: 700; font-size: 16px; margin-left: 10px"
        >Market Management</span
      >

       <b-button
        variant="outline-primary"
        class="ml-2"
        size="sm"
        @click="$bvModal.show('group-market')"
      >
        Show Market Group 
      </b-button>
      <b-button
        variant="outline-primary"
        class="ml-2"
        size="sm"
        @click="$bvModal.show('mapping-h2h')"
      >
        Crawling H2H Features
      </b-button>
       <b-button
        variant="outline-primary"
        class="ml-2"
        size="sm"
        @click="$bvModal.show('crawling-line-total')"
      >
        Crawling Line & Total Features
      </b-button>
    </div>


    <MarketGroupConfig />
    <MappingH2HModal />
    <CrawlingLineTotalModal />

    <div class="d-flex align-items-center mb-1">
      <feather-icon icon="GridIcon" size="20" />
      <span style="font-weight: 700; font-size: 16px; margin-left: 10px"
        >League Ignore Management</span
      >
    </div>

    <b-card>
      <b-row>
        <!-- SPORTS -->
        <b-col cols="12" lg="5" style="border-right: 1px solid #dae1e7">
          <div class="d-flex justify-content-between mb-1">
            <h5>SPORTS</h5>
            <div class="d-flex align-items-center">
              <b-form-checkbox v-model="checkActiveSport" switch />
              <span>Active</span>
            </div>
          </div>
          <div
            v-for="(sport, index) in sports"
            :key="sport.id"
            class="d-flex align-items-center p-1"
            :class="{
              'border-bot': index !== sports.length - 1,
              'active-item': selectedSport && selectedSport.id === sport.id,
            }"
            style="cursor: pointer; gap: 16px"
            @click="selectSport(sport)"
          >
            <feather-icon icon="AlignCenterIcon" class="text-muted" />
            {{ sport.name }}
          </div>
        </b-col>
        <!-- LEAUGE -->
        <b-col cols="12" lg="7">
          <div class="border-bottom pb-1">
            <div v-if="selectedSport" style="font-weight: 900; color: black">
              <span style="font-weight: 300">List Ignore Leagues for:</span>
              {{ selectedSport.name }}
            </div>
            <div
              class="d-flex align-items-center justify-content-end"
              style="gap: 5px; margin-top: 5px"
            >
              <b-button
                variant="primary"
                style="padding: 6px 10px; font-size: 12px"
                @click="showModalAddConfig"
                >Add new ignore league</b-button
              >
            </div>
          </div>

          <template>
            <div
              v-if="leagues && leagues.length > 0"
              class="mt-1 d-flex flex-column"
              style="gap: 5px"
            >
              <div
                v-for="(league, index) in leagues"
                :key="league.id"
                class="d-flex align-items-center justify-content-between p-1 market-outline"
                style="gap: 16px"
              >
                <div class="d-flex align-items-center" style="gap: 10px">
                  <feather-icon icon="AlignCenterIcon" class="text-muted" />
                  <span>{{ index + 1 }}, {{ league.leagueName }}</span>
                </div>
                <feather-icon
                  size="20"
                  icon="TrashIcon"
                  class="ml-1 text-danger cursor-pointer"
                  @click="showModal('delete', league)"
                />
              </div>
            </div>
            <div class="mt-3 text-center" v-else>No item in list</div>
          </template>
        </b-col>
      </b-row>
    </b-card>

    <!-- League & Team Name Mapping -->
     <LeagueMapping />

    <!-- MODAL ADD/UPDATE -->
    <b-modal
      ref="config"
      :title="modalTitle"
      centered
      cancel-variant="outline-secondary"
      hide-footer
      @hide="hideModalSetting"
    >
      <div style="color: black">
        <p class="m-0" style="padding-bottom: 5px">New League Name</p>
        <b-form-input
          v-model="newLeagueName"
          class="border"
          placeholder="Enter market name"
        />
      </div>
      <b-row>
        <b-col class="d-flex justify-content-end mt-2">
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            :disabled="isLoading"
            @click="handleSaveDataConfig"
          >
            <Spinner v-if="isLoading" />
            <template v-else> Save </template>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isLoading"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isLoading" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BIcon,
  BFormCheckbox,
  BFormInput,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import draggable from "vuedraggable";
import Spinner from "@/@core/components/Spinner.vue";
import vSelect from "vue-select";
import MarketGroupConfig from "./MarketGroupConfig.vue";
import MappingH2HModal from "./MappingH2HModal.vue";
import CrawlingLineTotalModal from "./CrawlingLineTotalModal.vue";
import LeagueMapping from "./LeagueMapping.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
    BFormCheckbox,
    draggable,
    BFormInput,
    BCardText,
    Spinner,
    vSelect,
    MarketGroupConfig,
    MappingH2HModal,
    CrawlingLineTotalModal,
    LeagueMapping,
  },
  data() {
    return {
      sports: [],
      checkActiveSport: true,
      selectedSport: null,
      leagues: [],

      dataMarket: null,
      marketNames: [],
      newLeagueName: "",
      activeSource: "sporting",
      optionsSource: [
        { label: "Sporting", value: "sporting" },
        { label: "RAS", value: "RAS" },
        { label: "Pricekinetic", value: "pricekinetic" },
        { label: "Manual", value: "manual" },
      ],
      modalTitle: "",

      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
    };
  },
  async mounted() {
    await this.fetchSports();
    this.selectedSport = this.sports[0];
  },
  watch: {
    checkActiveSport(val) {
      this.fetchSports();
    },
    selectedSport() {
      this.fetchLeagueIgnoreConfig();
    },
  },
  computed: {
    ...mapState("trading/config", ["loadingCreateNewConfig", "loadingDelete"]),
    isLoading() {
      return this.loadingCreateNewConfig || this.loadingDelete;
    },
  },
  methods: {
    ...mapActions({
      getListSport: "sport/list/getListSport",
      getListLeagueConfig: "trading/config/getListLeagueConfig",
      deleteLeagueConfig: "trading/config/deleteLeagueConfig",
      createNewLeagueConfig: "trading/config/createNewLeagueConfig",
    }),
    async fetchSports() {
      const data = await this.getListSport({
        limit: 100,
        page: 1,
        ...(this.checkActiveSport && { status: "active" }),
        source: this.activeSource,
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      this.sports = data.data;
    },
    async fetchLeagueIgnoreConfig() {
      const data = await this.getListLeagueConfig({
        sportId: this.selectedSport.id,
      });
      if (Array.isArray(data.data)) {
        this.leagues = data.data;
      }
    },
    async selectSport(sport) {
      this.selectedSport = sport;
    },

    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete")
        this.setModal(
          "Delete Leauge",
          `Are you sure you want to delete league name ${item.leagueName.toUpperCase()}?`
        );

      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type, item } = this.action;
      if (type === "delete") await this.handleDelete(item);

      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleSaveDataConfig(event) {
      event.preventDefault();
      if (!this.newLeagueName)
        return this.showToastError(false, "Please enter league name");
      const res = await this.createNewLeagueConfig({
        sportId: this.selectedSport.id,
        source: this.activeSource,
        leagueNames: [this.newLeagueName],
      });
      if (res) {
        this.showToastSuccess(
          true,
          "List leagues config updated successfully!"
        );
        this.$refs.config.hide();
        this.fetchLeagueIgnoreConfig();
      }
    },
    showModalAddConfig() {
      this.modalTitle = "New Config";
      this.$refs.config.show();
    },
    hideModalSetting() {
      this.newLeagueName = "";
    },
    async handleDelete(item) {
      const res = await this.deleteLeagueConfig({
        sportId: this.selectedSport.id,
        id: item.id,
      });
      if (res) {
        this.showToastSuccess(true, "League deleted successfully!");
        this.fetchLeagueIgnoreConfig();
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>


<style lang="scss" scoped>
.border-bot {
  border-bottom: 1px solid #dae1e7;
}

.active-item {
  color: #0d6efd;
  font-weight: bold;
  border-left: 2px solid #0d6efd;
  background: #e7f1ff;
}

.market-outline {
  padding: 20px;
  border: 1px solid #dae1e7;
  border-radius: 10px;
}
</style>